export const shipmentPrefixOptions = [
  {
    label: 'AG (Customer Apps)',
    value: 'AG',
  },
  {
    label: 'AO (Customer Apps)',
    value: 'AO',
  },
  {
    label: 'ARA (Customer Apps)',
    value: 'ARA',
  },
  {
    label: 'T1 (Marketplace)',
    value: 'T1',
  },
  {
    label: 'B1 (Marketplace)',
    value: 'B1',
  },
  {
    label: 'DO (Delivery Order)',
    value: 'DO',
  },
  {
    label: 'C1 (Corporate)',
    value: 'C1',
  },
  {
    label: 'CP (Corporate)',
    value: 'CP',
  },
]

export const sttPrefixOptions = [
  {
    label: '10',
    value: '10',
  },
  {
    label: '11',
    value: '11',
  },
  {
    label: '19',
    value: '19',
  },
  {
    label: '88 (General)',
    value: '88',
  },
  {
    label: '88 (C1)',
    value: '88-C1',
  },
  {
    label: '88 (AG)',
    value: '88-AG',
  },
  {
    label: '88 (T1)',
    value: '88-T1',
  },
  {
    label: '88 (B1)',
    value: '88-B1',
  },
  {
    label: '88 (B2)',
    value: '88-B2',
  },
  {
    label: '88 (ARA)',
    value: '88-ARA',
  },
  {
    label: '89',
    value: '89',
  },
  {
    label: '94',
    value: '94',
  },
  {
    label: '96',
    value: '96',
  },
  {
    label: '95',
    value: '95',
  },
  {
    label: '99',
    value: '99',
  },
  {
    label: '98',
    value: '98',
  },
  {
    label: '77',
    value: '77',
  },
  {
    label: '78',
    value: '78',
  },
]

export const codMultiplyOptions = [
  {
    label: 'KG',
    value: 'kg'
  },
  {
    label: 'Persentase',
    value: 'percentage'
  },
  {
    label: 'Flat',
    value: 'flat'
  }
]
